<template>
  <div class="td-forget">
    <el-row>
      <div class="td-form-item">
        <el-col :span="24">
          <el-input
            placeholder="请输入手机号"
            v-model="params.Mobile"
            style="width:100%;"
            prefix-icon="icon font_family icon-td-phone"
          ></el-input>
        </el-col>
      </div>
      <div class="td-form-item">
        <el-col :span="24">
          <el-input
            type="password"
            placeholder="请输入密码"
            v-model="params.NewPwd"
            style="width:100%;"
            prefix-icon="icon font_family icon-td-mima"
          ></el-input>
        </el-col>
      </div>
      <div class="td-form-item">
        <el-col :span="24">
          <el-input
            type="password"
            placeholder="请输入确认密码"
            v-model="params.PasswordTwo"
            style="width:100%;"
            prefix-icon="icon font_family icon-td-mima"
          ></el-input>
        </el-col>
      </div>
      <div class="td-form-item">
        <el-col :span="24">
          <el-input
            placeholder="请输入验证码"
            v-model="params.ValidateCode"
            style="width:100%;"
            prefix-icon="icon font_family icon-td-youxiang"
          ></el-input>
          <el-button
            type="primary"
            class="btnSend"
            size="mini"
            round
            @click="getAuthCode();"
            v-if="sendAuthCode"
          >获取验证码</el-button>
          <el-button
            type="primary"
            class="btnSend"
            size="mini"
            round
            v-if="!sendAuthCode"
          >{{auth_time}}秒后重试</el-button>
        </el-col>
      </div>
      <div class="td-form-item td-form-doctor-label">
        <el-col :span="12">
          <router-link to="/tdLogin">用户登录</router-link>
        </el-col>
        <el-col :span="12" style="text-align:right;">
          <router-link to="/tdRegistered">新用户注册</router-link>
        </el-col>
      </div>
      <div class="td-form-item">
        <el-col :span="24" style="text-align:center;">
          <el-button
            type="primary"
            class="td-btn-doctor-primary"
            style="width:80%;"
            @click="btnSubmit();"
            round
          >确认</el-button>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import AuthService from "../_services/auth.service";
import UserService from "../_services/user.service";
import DoctorService from "../_services/doctor.service";
export default {
  name: "TianDingForgetComponent",
  data() {
    return {
      params: {
        Mobile: "",
        NewPwd: "",
        PasswordTwo: "",
        ValidateCode: ""
      },
      ValidateCode: "",
      sendAuthCode: true,
      auth_time: 0
    };
  },
  mounted() {},
  methods: {
    async getAuthCode() {
      if (!this.params.Mobile) {
        this.toast$("请输入手机号");
        return;
      }

      this.sendAuthCode = false;
      this.auth_time = 60;

      var auth_timetimer = setInterval(() => {
        this.auth_time--;
        if (this.auth_time <= 0) {
          this.sendAuthCode = true;
          clearInterval(auth_timetimer);
        }
      }, 1000);

      let params = {};
      params.mobile = this.params.Mobile;

      try {
        let result = await AuthService.sendMsg(params);

        if (result && result.Data) {
          if (result.Data.ReturnMsg === "发送成功") {
            this.ValidateCode = result.Data.SendCode;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async btnSubmit() {
      if (!this.params.Mobile) {
        this.toast$("请输入手机号");
        return;
      }

      if (!this.params.NewPwd) {
        this.toast$("请输入密码");
        return;
      }

      if (!this.params.PasswordTwo) {
        this.toast$("请输入确认密码");
        return;
      }

      if (this.params.NewPwd !== this.params.PasswordTwo) {
        this.toast$("两次输入密码不一致");
        return;
      }

      if (
        this.encry$.MD5Encryption(this.params.ValidateCode) !==
        this.ValidateCode
      ) {
        this.toast$("请输入正确的验证码");
        return;
      }

      this.indicator$.open("请稍后...");

      try {
        let result = await DoctorService.forgetPassword(this.params);

        let { Data } = result;

        if (Data > 0) {
          this.toast$("密码修改成功");
        } else {
          this.toast$("密码修改失败");
        }
        this.$router.push({ name: "tdLogin" });
        this.indicator$.close();
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/views/forget.vue